/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_HighlightsInputs */

const en_label_highlights = /** @type {(inputs: Label_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highlights`)
};

const es_label_highlights = /** @type {(inputs: Label_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacados`)
};

const fr_label_highlights = /** @type {(inputs: Label_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps forts`)
};

const de_label_highlights = /** @type {(inputs: Label_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highlights`)
};

const id_label_highlights = /** @type {(inputs: Label_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorotan`)
};

/** @type {(inputs: Label_HighlightsInputs) => LocalizedString} */
const ja_label_highlights = en_label_highlights;

/** @type {(inputs: Label_HighlightsInputs) => LocalizedString} */
const zh_label_highlights = en_label_highlights;

/** @type {(inputs: Label_HighlightsInputs) => LocalizedString} */
const ar_label_highlights = en_label_highlights;

/** @type {(inputs: Label_HighlightsInputs) => LocalizedString} */
const it_label_highlights = en_label_highlights;

/** @type {(inputs: Label_HighlightsInputs) => LocalizedString} */
const ru_label_highlights = en_label_highlights;

/** @type {(inputs: Label_HighlightsInputs) => LocalizedString} */
const pt_label_highlights = en_label_highlights;

/** @type {(inputs: Label_HighlightsInputs) => LocalizedString} */
const ko_label_highlights = en_label_highlights;

/**
* | output |
* | --- |
* | "Highlights" |
*
* @param {Label_HighlightsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_highlights = /** @type {((inputs?: Label_HighlightsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_HighlightsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_highlights(inputs)
	if (locale === "es") return es_label_highlights(inputs)
	if (locale === "fr") return fr_label_highlights(inputs)
	if (locale === "de") return de_label_highlights(inputs)
	if (locale === "ja") return ja_label_highlights(inputs)
	if (locale === "zh") return zh_label_highlights(inputs)
	if (locale === "ar") return ar_label_highlights(inputs)
	if (locale === "id") return id_label_highlights(inputs)
	if (locale === "it") return it_label_highlights(inputs)
	if (locale === "ru") return ru_label_highlights(inputs)
	if (locale === "pt") return pt_label_highlights(inputs)
	return ko_label_highlights(inputs)
});